
export default {
  name: 'AppTextInput',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    maxlength: { type: Number, default: null },
    invalid: { type: Boolean, default: false }
  }
};
